import styled from 'styled-components'
import { logos } from '../../styles/images'

const DEFAULT_SIZE = 28

const Mark = styled.img<{ $size: number }>`
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    flex-shrink: 0;
    pointer-events: none;
    user-select: none;
`

interface ShellLogoProps {
    size?: number
    className?: string
}
// The one GT mark for the signed-in shell: expanded sidebar, collapsed rail, mobile app bar and
// drawer all render this, so they cannot drift apart. Callers choose a size, never the asset. The
// yellow circle carries its own ink outline, so it needs no container to read on panel surfaces.
const ShellLogo = ({ size = DEFAULT_SIZE, className }: ShellLogoProps) => (
    <Mark src={logos.generaltask_yellow_circle} alt="General Task" $size={size} className={className} data-shell-logo />
)

export default ShellLogo
